import SampleModel from "@/models/lab/SampleModel";
import LabServiceCollection from "@/collections/LabServiceCollection";
import SampleStatusCollection from "./SampleStatusCollection";

/**
 * Sample collection
 */
export default class SampleCollection extends LabServiceCollection {

  options() {
    let options = super.options() || {};
    options.methods = this.methods();
    return options;
  }

  // Model that is contained in this collection.
  model() {
    return SampleModel;
  }

  methods() {
    return {
      fetch: "GET",
      fetchByLatestStatus: "GET",
      save: "POST",
      delete: "DELETE"
    }
  }

  // Route configuration
  routes() {
    let model = (new (this.model())());
    let routes = super.routes();
    routes['fetchByLatestStatus'] = process.env.VUE_APP_LAB_REPOSITORY_URL + '/api/v1/' + model.modelName() + '/sample-status/{sample_status}/latest';
    return routes;
  }

  fetchByLatestStatus(sample_status, params) {
    let method = this.getOption('methods.fetchByLatestStatus');
    let route = this.getRoute('fetchByLatestStatus');
    if(sample_status.id) {
      let url = this.getURL(route, {sample_status: sample_status.id});
      return this.createRequest({method, url, params}).send()
        .then(this.handleCustomFetchSuccess)
        .catch(this.handleCustomFetchFailure);
    }
    return null;
  }

}
